import { useEffect, useRef, useState } from 'react';

export const SingleInputForm = ({ InputComponent, autoFocus, value, sanitize, onSubmit, onEnterPress, validate, ...rest }) => {
  const [localValue, setLocalValue] = useState(value || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    autoFocus && ref?.current?.focus();
  }, [ref?.current]);

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (e) => {
    const value = sanitize ? sanitize(e.target.value) : e.target.value;
    setLocalValue(value);

    if (validate) {
      const validationError = validate(value);
      setError(validationError);
    }

    rest.onChange?.(value);
  };

  const handleBlur = async (e) => {
    rest.onBlur?.(e);

    if (localValue === value) return;

    const error = validate(localValue);
    if (error) return;

    setLoading(true);
    await onSubmit?.({ value: localValue });
    setLoading(false);
  };

  const handleFocus = (e) => {
    rest.onFocus?.(e);
  };

  const handleKeyDown = async (e) => {
    if (loading) return;
    if (e.key !== 'Enter') return;
    ref.current?.blur();

    onEnterPress?.()
  };

  return (
    <InputComponent
      {...rest}
      ref={ref}
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      loading={loading || rest.loading}
      onKeyDown={handleKeyDown}
      hasError={Boolean(error)}
      error={{ message: error }}
    />
  );
};
